import React from "react";

import AboutUsSection from "../../about-us";


const AboutPage = () => {
  return (
    <>
      <section className="about-page">
      <AboutUsSection/>
      </section>
    </>
  );
};

export default AboutPage;
